<div [formGroup]="parentFormGroup" class="form-container">
  <mat-form-field appearance="outline">
    <mat-label i18n>Available capacity</mat-label>
    <input matInput id="capacity-available" type="number" formControlName="available">
  </mat-form-field>
</div>
